import company from './company.json';
import general from './general.json';
import hum from './hum.json';
import messaging from './messaging.json';
import profile from './profile.json';
import returns from './returns.json';
import track from './track.json';
import wysiwyg from './wysiwyg.json';
import returnRules from './returnRules.json';
import trackEdd from './trackEdd.json';
import trackStyle from './trackStyle.json';
import returnBranding from './returnBranding.json';
import returnsBrandingColors from './returnsBrandingColors.json';
import workingDays from './workingDays.json';
import holiday from './holiday.json';
import eddPreview from './eddPreview.json';

export default {
  eddPreview,
  holiday,
  workingDays,
  general,
  company,
  hum,
  messaging,
  profile,
  returns,
  track,
  wysiwyg,
  returnRules,
  trackEdd,
  trackStyle,
  returnBranding,
  returnsBrandingColors,
};
